import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_QUERY_PARAM,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
  normalizeLanguage,
} from "./languages"
import en from "./locales/en.json"
import es from "./locales/es.json"
import ptBR from "./locales/pt-BR.json"

export const resources = {
  "pt-BR": { translation: ptBR },
  en: { translation: en },
  es: { translation: es },
} as const

const syncHtmlLang = (language: string) => {
  if (typeof document !== "undefined") document.documentElement.lang = language
}

/**
 * Ordem de precedência: escolha manual do usuário (localStorage, gravado só pelo seletor)
 * > ?lang= na URL > idioma do navegador > pt-BR. O cache automático do detector fica
 * desligado (caches: []) para o idioma detectado do navegador não "grudar" no localStorage.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: DEFAULT_LANGUAGE,
    load: "currentOnly",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ["localStorage", "querystring", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      lookupQuerystring: LANGUAGE_QUERY_PARAM,
      caches: [],
      convertDetectedLanguage: normalizeLanguage,
    },
  })

syncHtmlLang(i18n.resolvedLanguage ?? DEFAULT_LANGUAGE)
i18n.on("languageChanged", syncHtmlLang)

/** Troca o idioma por escolha explícita do usuário e a mantém nas próximas visitas. */
export const changeLanguageManually = async (language: string) => {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizeLanguage(language))
  await i18n.changeLanguage(normalizeLanguage(language))
}

export * from "./languages"
export * from "./countryNames"
export * from "./frequency"
export default i18n
